import { render, staticRenderFns } from "./ReRestrictions.vue?vue&type=template&id=0cb57c69&scoped=true"
import script from "./ReRestrictions.vue?vue&type=script&lang=js"
export * from "./ReRestrictions.vue?vue&type=script&lang=js"
import style0 from "./ReRestrictions.vue?vue&type=style&index=0&id=0cb57c69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb57c69",
  null
  
)

export default component.exports